// removed by extract-text-webpack-plugin
module.exports = {"textBarChart":"text-barchart-module__textBarChart___11aoV","barWrapper":"text-barchart-module__barWrapper___28UlK","bar":"text-barchart-module__bar___3PR4m","barText":"text-barchart-module__barText___2OBcR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/bar-chart/text-barchart.module.scss
// module id = 665
// module chunks = 0 1